export default "__VITE_ASSET__Ci44dA0H__"